// extracted by mini-css-extract-plugin
export var text = "_7a-0";